import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
import { IMAGES } from '../data/funnel';
const stats = [{
  value: '$1,024',
  label: 'prima anual promedio del seguro médico para un Frenchie en USA'
}, {
  value: '1 de 4',
  label: 'desarrolla algún grado de compresión discal antes de los 6 años'
}, {
  value: '7 min',
  label: 'al día es lo que toma la rutina de columna del protocolo'
}];
export function BridgePage() {
  return <main className="w-full bg-paper pb-24" data-id="element-39" data-mp="1m6bvilkssrqe">
      <header className="border-b border-navy-deep/10 bg-paper" data-id="element-40" data-mp="1m4ipn8i0ebjg">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3.5" data-id="element-41" data-mp="1h67emufz9uzn">
          <span className="font-display text-lg font-bold tracking-tight text-navy-deep" data-id="element-42" data-mp="1c8fn41j8wavz">
            The Frenchie Longevity Report
          </span>
          <span className="hidden text-[11px] font-semibold uppercase tracking-[0.16em] text-navy/45 sm:block" data-id="element-43" data-mp="3bk8o0995m0dz">
            Salud canina · Investigación
          </span>
        </div>
      </header>

      <article className="mx-auto max-w-read px-5" data-id="element-44" data-mp="1zw44trtx8pfn">
        <div className="pt-10 sm:pt-14" data-id="element-45" data-mp="23zioqtkzdpyd">
          <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-alert" data-id="element-46" data-mp="240k77j4bteq4">
            Reporte especial
          </span>
          <h1 className="mt-4 font-display text-3xl font-bold leading-[1.15] tracking-tight text-navy-deep sm:text-[2.65rem]" data-id="element-47" data-mp="1uy2nbbc58y6a">
            Por qué los dueños de Bulldogs Franceses en USA están abandonando las croquetas
            tradicionales y adoptando este nuevo “Protocolo de Longevidad”
          </h1>
          <div className="mt-6 flex flex-wrap items-center gap-x-3 gap-y-1 border-y border-navy-deep/10 py-3 text-sm text-navy/60" data-id="element-48" data-mp="28ylt0bt4zs5a">
            <span className="font-semibold text-navy" data-id="element-49" data-mp="2dvvpgbey142m">Por el equipo editorial de FLR</span>
            <span aria-hidden="true" data-id="element-50" data-mp="31lq0cnfpcik8">·</span>
            <span data-id="element-51" data-mp="31ky6pi5o0uwl">Lectura de 4 minutos</span>
            <span aria-hidden="true" data-id="element-52" data-mp="36drdscolwfbu">·</span>
            <span data-id="element-53" data-mp="36fkktt34t1kd">Actualizado esta semana</span>
          </div>
        </div>

        <figure className="mt-8" data-id="element-54" data-mp="3g8y7nd5w43qx">
          <img src={IMAGES.park} alt="Bulldog Francés adulto corriendo con energía en un parque urbano" className="aspect-[16/9] w-full rounded-lg object-cover" data-id="element-55" data-mp="3g73tqit1dbwc" />
          <figcaption className="mt-2 text-xs text-navy/50" data-id="element-56" data-mp="329p011vr2hyk">
            Bruno, 9 años. Su dueña llevaba dos años escuchando que “esta raza envejece así”.
          </figcaption>
        </figure>

        <div className="mt-10 space-y-6 text-[1.0625rem] leading-[1.75] text-navy-deep/85 sm:text-lg" data-id="element-57" data-mp="2sjvtifagst16">
          <p data-id="element-58" data-mp="2nkso2tqkokso">
            <span className="float-left mr-3 mt-1 font-display text-[3.25rem] font-bold leading-[0.8] text-navy-deep" data-id="element-59" data-mp="2nk9fw4qq5aru">
              ¿
            </span>
            Sabías que el Bulldog Francés es la raza con el seguro médico más caro de Estados Unidos?
            No es coincidencia. La mayoría de los dueños están atrapados en un ciclo de “reacción”:
            esperan a que el perro tenga una hernia o un golpe de calor para actuar.
          </p>

          <p data-id="element-60" data-mp="p539nfs57sr3">
            Pero un pequeño grupo de dueños está logrando lo imposible: perros de 12 y 14 años que
            todavía corren en el parque. Su secreto no es una medicina mágica, es el{' '}
            <strong className="font-semibold text-navy-deep" data-id="element-61" data-mp="y1kk0gsonmls">Biohacking Proactivo</strong>.
          </p>

          <blockquote className="border-l-2 border-gold pl-5 font-display text-xl font-medium leading-snug text-navy-deep sm:text-[1.4rem]" data-id="element-62" data-mp="130e26mix01sa">
            “El daño no aparece a los 8 años. Aparece a los 2, en silencio, y se cobra la factura a
            los 8.”
          </blockquote>

          <p data-id="element-63" data-mp="fbupzvwqv4ux">
            La diferencia entre esos dos grupos rara vez es el dinero o el veterinario. Es el orden
            de las decisiones: qué se retira del plato primero, cómo se descomprime la columna antes
            de que duela, y cómo se maneja el calor antes de julio.
          </p>
        </div>

        <section aria-label="Datos del mercado en Estados Unidos" className="mt-10 grid gap-px overflow-hidden rounded-lg bg-navy-deep/10 sm:grid-cols-3" data-id="element-64" data-mp="3nqmlpek9cfh2">
          {stats.map(s => <div key={s.value} className="bg-cream p-5" data-id="element-65" data-mp="232k9si6d5s6p">
              <p className="font-display text-2xl font-bold text-navy-deep" data-id="element-66" data-mp="23450fwpk4qza">{s.value}</p>
              <p className="mt-1.5 text-sm leading-snug text-navy/70" data-id="element-67" data-mp="1yb279poozjjm">{s.label}</p>
            </div>)}
        </section>

        <div className="mt-10 space-y-6 text-[1.0625rem] leading-[1.75] text-navy-deep/85 sm:text-lg" data-id="element-68" data-mp="2d2uibphgebfj">
          <p data-id="element-69" data-mp="284157y62wmfw">
            En la siguiente página, descubrirás cómo el{' '}
            <strong className="font-semibold text-navy-deep" data-id="element-70" data-mp="2m0n1x5u7k58q">“Protocolo Spine-Shield”</strong> está
            salvando a miles de perros de la parálisis y cómo tú puedes empezar hoy mismo por menos
            de lo que cuesta un café.
          </p>
        </div>

        <div className="mt-10 rounded-xl border border-navy-deep/10 bg-cream p-6 sm:p-8" data-id="element-71" data-mp="nmlfoatkzwpg">
          <p className="text-sm font-semibold uppercase tracking-[0.14em] text-navy/50" data-id="element-72" data-mp="dhd5sb25kpxh">
            Siguiente paso
          </p>
          <p className="mt-2 font-display text-xl font-bold leading-snug text-navy-deep sm:text-2xl" data-id="element-73" data-mp="hi6u35jic6qw">
            Ve el protocolo completo de 30 días, paso a paso.
          </p>
          <Link to="/protocolo" className="group mt-5 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-gold px-6 py-4 text-base font-bold text-navy-deep shadow-card transition-colors duration-150 ease-out hover:bg-gold-light sm:w-auto sm:text-lg" data-id="element-74" data-mp="8qd6iz5k9vrt">
            Mira el Protocolo de Longevidad Aquí
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-75" data-mp="3h0ofzlli9v03" />
          </Link>
          <p className="mt-3 flex items-center gap-1.5 text-xs text-navy/55" data-id="element-76" data-mp="1f6pajgv2e7vb">
            <ShieldCheckIcon className="h-4 w-4 text-navy/40" data-id="element-77" data-mp="1k6bjvf7rv3yu" />
            Sin registro. Acceso inmediato a la página del protocolo.
          </p>
        </div>
      </article>

      <footer className="mx-auto mt-16 max-w-read border-t border-navy-deep/10 px-5 pt-6 text-xs leading-relaxed text-navy/45" data-id="element-78" data-mp="1hpk7lfuxsagj">
        Este contenido es informativo y no sustituye el diagnóstico de un veterinario licenciado.
        Los resultados varían según cada perro. © {new Date().getFullYear()} The Frenchie Longevity
        Report.
      </footer>
    </main>;
}